import React from "react";
import { IBTGame, defaultBTGame } from "./BTGameInterface";
export const BTGameContext = React.createContext<IBTGame>(defaultBTGame);
export const BTGameProvider = BTGameContext.Provider;
export const BTGameConsume = BTGameContext.Consumer;
